import { render } from "./callFollowUpList.vue?vue&type=template&id=40b2e621&scoped=true"
import script from "./callFollowUpList.vue?vue&type=script&lang=js"
export * from "./callFollowUpList.vue?vue&type=script&lang=js"

import "./callFollowUpList.vue?vue&type=style&index=0&id=40b2e621&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b2e621"]])

export default __exports__